import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { toast } from "react-toastify";
import ClearIcon from "@mui/icons-material/Clear";
import CheckIcon from "@mui/icons-material/Check";
import { Checklist } from "models/Checklist";
import { useSetDocumentationDoneMutation } from "app/api/checklists";

type EditDocumentationStatusProps = {
  checklist: Checklist;
  onClose: () => void;
};

const EditDocumentationStatus: React.FC<EditDocumentationStatusProps> = (props) => {
  const { checklist, onClose } = props;
  const [setDocumentationDone, { isLoading }] = useSetDocumentationDoneMutation();

  const handleChange = async () => {
    setDocumentationDone({
      documentationDone: !checklist.documentationDone,
      checklistId: checklist.id,
    })
      .unwrap()
      .then(() => {
        toast.success("Dokumentation uppdaterad!");
        onClose();
      })
      .catch(() => toast.error("Något gick fel när dokumentationen skulle redigeras."));
  };

  return (
    <Dialog open={true} onClose={onClose}>
      <DialogTitle>Ändra status för dokumentation</DialogTitle>

      <DialogContent dividers>
        {checklist.documentationDone ? (
          <DialogContentText>
            Ta bort nuvarande klarmarkering, och rensa namn och tidstämpel?
          </DialogContentText>
        ) : (
          <DialogContentText>
            Klarmarkera checklistan med ditt eget namn och nuvarande tid?
          </DialogContentText>
        )}
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" onClick={onClose} disabled={isLoading}>
          Avbryt
        </Button>
        <Button
          variant="contained"
          color={checklist.documentationDone ? "error" : "primary"}
          onClick={handleChange}
          loading={isLoading}
          startIcon={checklist.documentationDone ? <ClearIcon /> : <CheckIcon />}
        >
          {checklist.documentationDone ? "Ta bort" : "Klarmarkera"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditDocumentationStatus;
